/**
 * Strip server / template identity from a canvas element cloned onto another stage
 * (off-canvas → main, or duplicate-to-selected-location). If these fields are kept,
 * MyCanvas reload treats the clone as the same entity as the off-canvas original and
 * removes it via stripMainElementsDuplicatedOnOffCanvas.
 */
export function clearCrossCanvasCloneServerIdentity(element) {
  if (!element || typeof element !== "object") return element;
  const clearOffCanvasFlags = (obj) => {
    if (!obj || typeof obj !== "object") return obj;
    const out = { ...obj };
    delete out.isOffcanvas;
    delete out.isOffCanvas;
    delete out.is_off_canvas;
    return out;
  };
  const cleanNested = (nested) => {
    if (!nested || typeof nested !== "object") return nested;
    const n = clearOffCanvasFlags(nested);
    delete n.shape_id;
    delete n.id;
    delete n.text_box_id;
    delete n.canvas_text_box_id;
    delete n.text_box_content_id;
    delete n.canvasTextId;
    delete n.canvasTextBoxId;
    return n;
  };
  const next = clearOffCanvasFlags(element);
  delete next.shape_id;
  delete next.image_id;
  delete next.text_box_id;
  delete next.canvas_text_box_id;
  delete next.text_box_content_id;
  delete next.canvasTextId;
  delete next.canvasTextBoxId;
  if (next.shape_properties)
    next.shape_properties = cleanNested(next.shape_properties);
  if (next.shape_info) next.shape_info = cleanNested(next.shape_info);
  if (next.image_properties)
    next.image_properties = cleanNested(next.image_properties);
  return next;
}
